import {isAnyOf} from '@reduxjs/toolkit'

import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {APIStatus, OrderEntry, OrderPhase} from '@web/core/constants'
import {isSafeUrl} from '@web/helpers/path'
import makeSlice from '@web/slices/common/sliceMaker'

import {fetchSubscription} from '../../actions'

const commonSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchSubscription.pending, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addCase(fetchSubscription.fulfilled, (state, {payload: {subscriptionViewResult}}) => {
                state.scene = APIStatus.RESOLVED
                state.entryPoint = subscriptionViewResult.sellerRegisterType
                state.entry = OrderEntry.SUBSCRIPTION

                if (subscriptionViewResult.backUrl && isSafeUrl(subscriptionViewResult.backUrl)) {
                    state.backUrl = subscriptionViewResult.backUrl
                }
            })
            .addCase(fetchSubscription.rejected, (state) => {
                state.scene = APIStatus.REJECTED
            })
            .addCase(getShoppingSubscriptionResultInfo.fulfilled, (state) => {
                state.orderPhase = OrderPhase.RESULT
            })
            .addMatcher(isAnyOf(getShoppingSubscriptionResultInfo.pending), (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isAnyOf(getShoppingSubscriptionResultInfo.fulfilled), (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isAnyOf(getShoppingSubscriptionResultInfo.rejected), (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default commonSlice.reducer
export const actions = commonSlice.actions
